module.exports = __webpack_public_path__ + "img/Veronika_kendoje_1.e888efe5.jpg";